<template>
    <div class="retr__content">
        <div v-for="(el, idx) in retr.list" :key="`el-${idx}`" class="retr__rows-group">
            <div class="retr__row" :class="{ active: expandedIds.includes(idx) }">
                <table-row
                    bold
                    expandable
                    :element="el"
                    :name="el.contractor"
                    :value="el.bonus"
                    :percent="el.percent"
                    :is-active="expandedIds.includes(idx)"
                    @click.native="toggleExpand(idx)"
                >
                    <template #options>
                        <div class="retr__options"
                            :class="{ expandable: true }"
                            @click="toggleExpand(idx)"
                        />
                    </template>
                </table-row>

                <transition-slide>
                    <div v-if="expandedIds.includes(idx)">
                        <div class="retr__row-content">
                            <table-row
                                class="retr__row-second"
                                name="Wartość obrotu"
                                :element="el"
                                :value="el.value"
                                :percent="el.percent"
                                :reclamation-button="true"
                                @reclamation-click="onReclamationClick(el, 'Wartość obrotu')"
                            />
                            <table-row
                                class="retr__row-second"
                                name="Premia"
                                :value="el.bonus"
                                :percent="el.bonusPercent"
                                :bold="true"
                            />
                        </div>
                    </div>
                </transition-slide>
            </div>
        </div>
    </div>
</template>

<script>
import retrMixin from './retr.mixin.js'

export default {
    mixins: [retrMixin],

    methods: {
        toggleExpand(idx) {
            if (this.expandedIds.includes(idx)) {
                this.expandedIds = this.expandedIds.filter(id => id !== idx)
            } else {
                this.expandedIds.push(idx)
                this.fetchReclamations(this.retr.list[idx])
            }
        }
    }
}
</script>
